import { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

// Any save that fails, on any page, says why here. services/api.ts raises it, so no form can fail silently.
export default function ProblemNotice() {
  const [text, setText] = useState('');
  useEffect(() => {
    const on = (e: Event) => setText((e as CustomEvent).detail || 'That did not save. Please try again.');
    window.addEventListener('concept:problem', on);
    return () => window.removeEventListener('concept:problem', on);
  }, []);
  return (
    <Snackbar open={!!text} autoHideDuration={9000} onClose={(_, why) => { if (why !== 'clickaway') setText(''); }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ zIndex: 2000 }}>
      <Alert severity="warning" variant="filled" onClose={() => setText('')} sx={{ width: '100%' }}>{text}</Alert>
    </Snackbar>
  );
}
